import {ofType} from 'redux-observable-es6-compat';
import {TRemote} from '../actions';
import {catchError, filter, map, mergeMap} from 'rxjs/operators';
import {ASetUserParams} from '../actions/user-params.action';
import {of} from 'rxjs';
import {environment} from '../../../environments/environment';

export const fetchUserParamsEpic = (action$, _, {restApi}) => action$.pipe(
  ofType(TRemote.SET_REMOTE),
  filter(() => !environment.enableDesktopMode),
  mergeMap(({}) => restApi.get(`/params`).pipe(
    map(response => ASetUserParams(response)),
    catchError(() => of([])),
  ))
);
